import { Quarry } from '../types/catalog'

const KRR_PHONE = '(206) 255-2651'
const KRR_HOURS = 'Mon–Fri, 7:00a–4:00p'
const KRR_SURCHARGE = 4.15
const KRR_NOTE = 'Pick-up at plant · +$4.15/ton surcharges · WA sales tax unless reseller permit'

/** Plants on the Kangley / Cedar Mountain and Palmer Coking Coal price lists. */
export const quarries: Quarry[] = [
  {
    id: 'black-river',
    name: 'Kangley Rock & Recycling — Black River',
    operator: 'Kangley Rock & Recycling',
    siteCode: 'A-516',
    address: '510 Monster Rd SW',
    city: 'Renton',
    state: 'WA',
    zip: '98055',
    phone: KRR_PHONE,
    hours: KRR_HOURS,
    coords: { lat: 47.4676, lng: -122.238 },
    surchargePerUnit: KRR_SURCHARGE,
    pricingNote: KRR_NOTE,
  },
  {
    id: 'lake-francis',
    name: 'Kangley Rock & Recycling — Lake Francis',
    operator: 'Kangley Rock & Recycling',
    siteCode: 'A-458',
    address: '22501 SE Lk Francis Rd',
    city: 'Maple Valley',
    state: 'WA',
    zip: '98038',
    phone: KRR_PHONE,
    hours: KRR_HOURS,
    coords: { lat: 47.3706, lng: -121.9906 },
    surchargePerUnit: KRR_SURCHARGE,
    pricingNote: KRR_NOTE,
  },
  {
    id: 'ravensdale',
    name: 'Kangley Rock & Recycling — Ravensdale',
    operator: 'Kangley Rock & Recycling',
    siteCode: 'A-512',
    address: '32500 SE Kent-Kangley Rd',
    city: 'Ravensdale',
    state: 'WA',
    zip: '98051',
    phone: KRR_PHONE,
    hours: KRR_HOURS,
    coords: { lat: 47.3662, lng: -121.9464 },
    surchargePerUnit: KRR_SURCHARGE,
    pricingNote: KRR_NOTE,
  },
  {
    id: 'cedar-mountain',
    name: 'Cedar Mountain Reclamation',
    operator: 'Cedar Mountain Reclamation',
    siteCode: 'A-458',
    address: '17877 Cedar Grove Rd SE',
    city: 'Maple Valley',
    state: 'WA',
    zip: '98038',
    phone: KRR_PHONE,
    hours: KRR_HOURS,
    coords: { lat: 47.4315, lng: -122.067 },
    surchargePerUnit: KRR_SURCHARGE,
    pricingNote: 'Disposal site — dump fees only, no aggregate sales',
  },
  {
    id: 'palmer-black-diamond',
    name: 'Palmer Coking Coal — Black Diamond',
    operator: 'Palmer Coking Coal Co.',
    siteCode: 'PCC',
    address: '31407 SR 169',
    city: 'Black Diamond',
    state: 'WA',
    zip: '98010',
    phone: '(425) 432-4700',
    hours: 'Mon–Fri, 7:00a–4:00p · Sat, 7:00a–3:00p',
    coords: { lat: 47.3145, lng: -122.001 },
    surchargePerUnit: 0,
    pricingNote: 'U-haul list price · call for delivery · +3% on credit cards',
  },
  {
    id: 'ryterra-enumclaw',
    name: 'Ryterra Quarry',
    operator: 'Ryterra',
    siteCode: 'A-45',
    address: '31818 SE Enumclaw Chinook Pass Rd',
    city: 'Enumclaw',
    state: 'WA',
    zip: '98022',
    phone: '(360) 825-5635',
    hours: 'Mon–Fri, 7:00a–3:00p',
    coords: { lat: 47.1866, lng: -121.9265 },
    surchargePerUnit: 0,
    pricingNote: 'Pick-up at quarry · $45 minimum per load · delivery by quote · +3.5% on cards',
  },
  {
    id: 'wrq-kapowsin',
    name: 'Washington Rock Quarries — Kapowsin',
    operator: 'Washington Rock Quarries Inc.',
    siteCode: 'QSB-332',
    address: '10012 288th St E',
    city: 'Graham',
    state: 'WA',
    zip: '98338',
    phone: '(253) 262-1661',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.0243, lng: -122.2255 },
    surchargePerUnit: 0,
    pricingNote: 'Cash customer pick-up · $75 minimum purchase · delivery quoted per job',
  },
  {
    id: 'wrq-king-creek',
    name: 'Washington Rock Quarries — King Creek Pit',
    operator: 'Washington Rock Quarries Inc.',
    siteCode: 'PS-B-344',
    address: '22007 Orville Rd E',
    city: 'Orting',
    state: 'WA',
    zip: '98360',
    phone: '(253) 262-1661',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.0592, lng: -122.1573 },
    surchargePerUnit: 0,
    pricingNote: 'Cash customer pick-up · $75 minimum purchase · delivery quoted per job',
  },
  {
    id: 'randles-puyallup',
    name: 'Randles Sand & Gravel',
    operator: 'Randles Sand & Gravel',
    siteCode: 'RSG',
    address: '5802 192nd St E',
    city: 'Puyallup',
    state: 'WA',
    zip: '98375',
    phone: '(253) 531-6800',
    hours: 'Mon–Fri 6:30a–4:30p · Sat 8:00a–1:00p',
    coords: { lat: 47.1281, lng: -122.3383 },
    surchargePerUnit: 0,
    pricingNote: 'Picked-up price list · $25 minimum charge',
  },
  {
    id: 'miles-lakeview',
    name: 'Miles Resources — Lakeview Facility',
    operator: 'Miles Resources',
    siteCode: 'List A',
    address: '2800 104th Street Ct S',
    city: 'Lakewood',
    state: 'WA',
    zip: '98499',
    phone: '(253) 582-5181',
    hours: 'Mon–Fri, 7:00a–3:30p',
    coords: { lat: 47.1509, lng: -122.5063 },
    surchargePerUnit: 0,
    pricingNote: 'Picked-up recycled rock and plant aggregates · $20 minimum',
  },
  {
    id: 'squak-mtn',
    name: 'Squak Mtn Materials',
    operator: 'Squak Mtn Materials',
    siteCode: 'Recycle',
    address: '10430 Renton-Issaquah Rd SE',
    city: 'Issaquah',
    state: 'WA',
    zip: '98027',
    phone: '(425) 736-0495',
    hours: 'Mon–Fri, 7:00a–3:30p',
    coords: { lat: 47.5175, lng: -122.0917 },
    surchargePerUnit: 0,
    pricingNote:
      'Recycled products, FOB plant · $50 minimum per load · 3% card surcharge · call for stock and orders over 100 tons',
  },
  {
    id: 'msg-fennel',
    name: 'Miles Sand & Gravel — Fennel Resources',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'B-345',
    address: '11621 McCutcheon Rd E',
    city: 'Bonney Lake',
    state: 'WA',
    zip: '98391',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.1554, lng: -122.1556 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'msg-canyon',
    name: 'Miles Sand & Gravel — Canyon Resources',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'B-329',
    address: '6423 Canyon Rd E',
    city: 'Puyallup',
    state: 'WA',
    zip: '98371',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.1857, lng: -122.3556 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'msg-roy',
    name: 'Miles Sand & Gravel — Roy',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'B-333',
    address: '31110 SR 507 S',
    city: 'Roy',
    state: 'WA',
    zip: '98580',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 46.9955, lng: -122.5308 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'msg-olympia',
    name: 'Miles Sand & Gravel — Olympia',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'J-215',
    address: '6538 Gravel Ln NE',
    city: 'Lacey',
    state: 'WA',
    zip: '98516',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.0752, lng: -122.7554 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'msg-tenino',
    name: 'Miles Sand & Gravel — Tenino',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'J-205',
    address: '16424 Old Hwy 99 SE',
    city: 'Tenino',
    state: 'WA',
    zip: '98589',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 46.8608, lng: -122.8636 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'msg-shelton',
    name: 'Miles Sand & Gravel — Shelton',
    operator: 'Miles Sand & Gravel Company',
    siteCode: 'X-49',
    address: '3100 W Franklin St',
    city: 'Shelton',
    state: 'WA',
    zip: '98584',
    phone: '(253) 536-9100',
    hours: 'Mon–Fri, 7:00a–4:00p',
    coords: { lat: 47.2136, lng: -123.1183 },
    surchargePerUnit: 0,
    pricingNote: 'Column 2 price list · effective April 1, 2026 · priced by the ton',
  },
  {
    id: 'hm-woodinville',
    name: 'Heidelberg Materials — Woodinville Recycling Center',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'Recycle',
    address: '6524 240th St SE',
    city: 'Woodinville',
    state: 'WA',
    zip: '98072',
    phone: '(425) 485-5415',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.7402, lng: -122.1373 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing, environmental surcharge included · $75 min load · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-redmond',
    name: 'Heidelberg Materials — Redmond Quarry & Recycling',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'A-510',
    address: '18816 NE 80th St',
    city: 'Redmond',
    state: 'WA',
    zip: '98052',
    phone: '(425) 961-7289',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.6702, lng: -122.0665 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-south-enumclaw',
    name: 'Heidelberg Materials — South Enumclaw Sand & Gravel',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'A-44',
    address: '29410 SE Enumclaw Chinook Pass Rd',
    city: 'Enumclaw',
    state: 'WA',
    zip: '98022',
    phone: '(425) 389-3617',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.1866, lng: -121.9453 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-north-bend',
    name: 'Heidelberg Materials — North Bend Sand & Gravel',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'A-460',
    address: '47320 Grouse Ridge Access Rd',
    city: 'North Bend',
    state: 'WA',
    zip: '98045',
    phone: '(425) 961-7265',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.4957, lng: -121.7866 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-issaquah',
    name: 'Heidelberg Materials — Issaquah',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'A-189',
    address: '',
    city: 'Issaquah',
    state: 'WA',
    zip: '98027',
    phone: '',
    hours: 'Call dispatch (425) 961-7100 x2',
    coords: { lat: 47.5301, lng: -122.0326 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-thunder-mountain',
    name: 'Heidelberg Materials — Thunder Mountain Quarry',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'A-322',
    address: '27407 SE Ridge Access Rd',
    city: 'North Bend',
    state: 'WA',
    zip: '98045',
    phone: '(425) 766-3927',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.4441, lng: -121.7994 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-sumner',
    name: 'Heidelberg Materials — Sumner Sand & Gravel',
    operator: 'Heidelberg Materials (formerly Corliss Resources)',
    siteCode: 'B-29',
    address: '16805 64th St E',
    city: 'Sumner',
    state: 'WA',
    zip: '98390',
    phone: '(253) 649-8206',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.2032, lng: -122.2401 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-puyallup',
    name: 'Heidelberg Materials — Puyallup Sand & Gravel',
    operator: 'Heidelberg Materials (formerly Corliss Resources)',
    siteCode: 'B-312',
    address: '18001 Meridian E',
    city: 'Puyallup',
    state: 'WA',
    zip: '98375',
    phone: '(425) 961-7132',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.1351, lng: -122.2937 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-granite-falls',
    name: 'Heidelberg Materials — Granite Falls Quarry',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'D-344/345',
    address: '22022 Mountain Loop Hwy',
    city: 'Granite Falls',
    state: 'WA',
    zip: '98252',
    phone: '(360) 691-3542',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 48.0702, lng: -121.9231 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal · dump-fee dirt adds 3.6% WA refuse tax',
  },
  {
    id: 'hm-gold-bar',
    name: 'Heidelberg Materials — Gold Bar Sand & Gravel',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'D-351',
    address: '44716 US-2',
    city: 'Gold Bar',
    state: 'WA',
    zip: '98251',
    phone: '(360) 793-1272',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.8562, lng: -121.6801 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-cascade',
    name: 'Heidelberg Materials — Gold Bar Cascade Quarry',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'D-290',
    address: '43530 US-2',
    city: 'Gold Bar',
    state: 'WA',
    zip: '98251',
    phone: '(360) 793-1272',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.8583, lng: -121.7023 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-high-rock',
    name: 'Heidelberg Materials — High Rock Sand, Gravel & Quarry',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'D-309/336',
    address: '19221 High Rock Rd',
    city: 'Monroe',
    state: 'WA',
    zip: '98272',
    phone: '(425) 407-3302',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.8842, lng: -121.8556 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'hm-north-everett',
    name: 'Heidelberg Materials — North Everett Aggregates & HMA',
    operator: 'Heidelberg Materials (Northern Washington)',
    siteCode: 'N Everett',
    address: '222 W Marine View Dr',
    city: 'Everett',
    state: 'WA',
    zip: '98201',
    phone: '(425) 407-3307',
    hours: 'Call the scale · dispatch (425) 961-7100 x2',
    coords: { lat: 47.9955, lng: -122.2226 },
    surchargePerUnit: 0,
    pricingNote:
      'All-in pricing · $100 min load fee on pickups · PCR surcharge when diesel > $3.99/gal',
  },
  {
    id: 'cp-seattle-yard',
    name: 'CalPortland — Seattle Aggregate Yard',
    operator: 'CalPortland / Glacier Northwest',
    siteCode: 'Seattle Yard',
    address: '5902 W Marginal Way SW',
    city: 'Seattle',
    state: 'WA',
    zip: '98106',
    phone: '(206) 938-6761',
    hours: 'Call for scale hours · CB channel 4',
    coords: { lat: 47.553, lng: -122.36 },
    surchargePerUnit: 1.25,
    pricingNote:
      'FOB plant · +$1.25/ton fees (environmental $1.00, workers rights $0.25) · $50 min sale ($65 rockery) · $25 certified scale fee · energy fee applies',
  },
  {
    id: 'cp-pioneer-dupont',
    name: 'CalPortland — Pioneer Aggregates (DuPont)',
    operator: 'CalPortland / Glacier Northwest',
    siteCode: 'B-335',
    address: '4301 Pioneer Ave',
    city: 'DuPont',
    state: 'WA',
    zip: '98327',
    phone: '(253) 912-8500',
    hours: 'Call for scale hours',
    coords: { lat: 47.0979, lng: -122.6318 },
    surchargePerUnit: 1.25,
    pricingNote:
      'FOB plant · +$1.25/ton fees (environmental $1.00, workers rights $0.25) · $50 min sale · $25 certified scale fee · energy fee applies',
  },
  {
    id: 'mcclains-tacoma',
    name: "McClain's Soil Supply",
    operator: "McClain's Soil Supply",
    siteCode: 'MSS',
    address: '3773 S 74th St',
    city: 'Tacoma',
    state: 'WA',
    zip: '98409',
    phone: '(253) 472-8285',
    hours: 'Mon–Sat, 8:00a–4:15p · delivery 8:00a–3:00p for a fee',
    coords: { lat: 47.1907, lng: -122.457 },
    surchargePerUnit: 0,
    pricingNote:
      'Retail pick-up per cu yd · 1/2-yard rate shown · sales tax not included · delivery extra',
  },
  {
    id: 'carpinito-kent',
    name: 'Carpinito Brothers',
    operator: 'Carpinito Brothers',
    siteCode: 'CB',
    address: '1148 Central Ave N',
    city: 'Kent',
    state: 'WA',
    zip: '98032',
    phone: '(253) 854-5692',
    hours: 'Call for yard hours · you-haul year round',
    coords: { lat: 47.3897, lng: -122.2299 },
    surchargePerUnit: 0,
    pricingNote:
      'You-haul price per cu yd · delivery quoted separately for South King County · charge/resale accounts call to order',
  },
  {
    id: 'franklin-ridge',
    name: 'Franklin Ridge Sand and Gravel',
    operator: 'Green Section 30, LLC',
    siteCode: 'PS-A-514',
    address: '36000 Enumclaw Franklin Rd',
    city: 'Enumclaw',
    state: 'WA',
    zip: '98022',
    phone: '(253) 433-4130',
    hours: 'Call the scale · mine foreman (425) 577-2586',
    coords: { lat: 47.2306, lng: -121.9735 },
    surchargePerUnit: 0,
    pricingNote: 'Contractor picked-up price list · all loads determined by the scale person',
  },
  {
    id: 'icon-auburn',
    name: 'ICON Materials — Auburn Pit & Plant',
    operator: 'ICON Materials (A CRH Company)',
    siteCode: 'Auburn',
    address: '4040 Kersey Way SE',
    city: 'Auburn',
    state: 'WA',
    zip: '98092',
    phone: '(253) 839-2101',
    hours: 'Mon–Fri, 7:00a–3:30p · asphalt plant (253) 981-6305',
    coords: { lat: 47.268, lng: -122.172 },
    surchargePerUnit: 0.85,
    pricingNote:
      'F.O.B. plant site · sand & gravel adds $0.50/ton environmental + $0.35/ton fuel surcharge · asphalt subject to the U.S. West Coast fuel index',
  },
]

export const priceListSources = [
  {
    id: 'krr',
    label: 'Kangley Rock & Recycling · Cedar Mountain Reclamation',
    detail: 'Contractor pricing 2026 — effective July 20, 2026 (revised 7/14/2026)',
  },
  {
    id: 'pcc',
    label: 'Palmer Coking Coal Co.',
    detail: 'U-haul pricing — palmercokingcoal.com/pricing, pickup (0–3.5 t) / dumptruck (3.5 t+)',
  },
  {
    id: 'ryterra',
    label: 'Ryterra Quarry (WSDOT A-45)',
    detail: 'Material price sheet — effective January 1, 2026, $45 minimum per load',
  },
  {
    id: 'wrq',
    label: 'Washington Rock Quarries Inc. — Kapowsin QSB-332, King Creek PS-B-344',
    detail: '2026 cash customer picked-up pricing — $75 minimum purchase, tax not included',
  },
  {
    id: 'icon-materials',
    label: 'ICON Materials (CRH) — Auburn Pit & Plant',
    detail: 'Auburn Pit & Plant price list, per ton F.O.B. — effective January 1, 2026',
  },
  {
    id: 'franklin-ridge',
    label: 'Franklin Ridge Sand and Gravel — Enumclaw (PS-A-514)',
    detail: 'Green Section 30, LLC contractor picked-up price list — effective July 1, 2026',
  },
  {
    id: 'carpinito',
    label: 'Carpinito Brothers — Kent',
    detail: 'store.carpinito.com you-haul pricing per cubic yard — read September 2026',
  },
  {
    id: 'mcclains',
    label: "McClain's Soil Supply — Tacoma",
    detail: 'Retail pricing — per cubic yard, 1-yard and 1/2-yard rates, pick-up Mon–Sat',
  },
  {
    id: 'calportland',
    label: 'CalPortland / Glacier NW — Pioneer Aggregates, DuPont (B-335)',
    detail: 'Aggregate price list — effective January 1, 2026, FOB plant per ton',
  },
  {
    id: 'calportland-seattle',
    label: 'CalPortland / Glacier NW — Seattle Aggregate Yard, W Marginal Way',
    detail: 'Aggregate price list — effective January 1, 2026, FOB plant per ton, +$1.25/ton fees',
  },
  {
    id: 'heidelberg',
    label: 'Heidelberg Materials — 13 sites, Snohomish through Pierce County',
    detail:
      'Northern Washington aggregate list — effective July 1 through December 31, 2026 (Snohomish/North King, King/South King, Greater Tacoma)',
  },
  {
    id: 'miles',
    label: 'Miles Resources — Lakeview asphalt plant, Lakewood',
    detail: 'Materials Price List A — effective February 16, 2026 (asphalt, recycled rock, sand)',
  },
  {
    id: 'randles',
    label: 'Randles Sand & Gravel — Puyallup (incl. Lynch Creek Quarry)',
    detail: '2026 picked-up price list — dated May 18, 2026, $25 minimum charge',
  },
  {
    id: 'miles-sand-gravel',
    label: 'Miles Sand & Gravel — 6 plants, Bonney Lake through Shelton',
    detail: 'Column 2 price list — effective April 1, 2026, priced by the ton',
  },
  {
    id: 'squak-mtn-materials',
    label: 'Squak Mtn Materials — Issaquah',
    detail: 'Recycled products price list — FOB plant, $50 minimum per load, 3% card surcharge',
  },
]
